import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiBreadcrumbs: ComponentOverride<'MuiBreadcrumbs'> = {
  MuiBreadcrumbs: {
    styleOverrides: {
      li: {
        '& p': {
          ...typography.body2,
        },
        '& a': {
          ...typography.body2,
          color: palette.grey[500],
          '&:visited, &:hover, &:focus, &:active': {
            color: palette.grey[500],
          },
        },
      },
      separator: {
        marginLeft: 12,
        marginRight: 12,
        color: palette.grey[500],
      },
    },
  },
};
